<template>
  <form
    @submit.prevent="onSave">
    <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <a class="h6" href="javascript:void(0)"
            @click="onView"
          >
            <i class="uil-arrow-left"></i> {{$t('currency.plural')}} 
          </a>
        </div>
        <div class="col-sm-8 col-xl-8 text-sm-right">
          <router-link
            tag="button"
            :to="'edit?id=' + $route.query.id"
            class="btn btn-info btn-sm"
          >
            <i class="uil uil-edit mr-1"></i> {{$t('common.edit')}}
          </router-link>
        </div>
        
      </div>
    </fixed-header>

    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
      {{errorMessage}}
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{$t('currency.form.information')}}</h4>
            <p class="sub-header"></p>

            <div class="row">
              <div class="form-group col-md-2">
                <label for="" class="form-label">{{$t('currency.form.symbol.label')}}</label>
                <input 
                  type="text" 
                  readonly="" 
                  class="form-control-plaintext"
                  v-model="model.symbol">
              </div>

              <div class="form-group col-md-5">
                <label for="" class="form-label">{{$t('currency.form.code.label')}}</label>
                <input 
                  type="text" 
                  readonly="" 
                  class="form-control-plaintext"
                  v-model="model.code">
              </div>

              <div class="form-group col-md-5">
                <label for="" class="form-label">{{$t('currency.form.name.label')}}</label>
                <input 
                  type="text" 
                  readonly="" 
                  class="form-control-plaintext"
                  v-model="model.name">
              </div>

            </div>

            <div class="row">

              <div class="col-md-6">
                <label for="" class="form-label">{{$t('currency.form.remarks.label')}}</label>
                <p>{{model.remarks || '-------'}}</p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </form>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import { required } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'


export default {
  mixins: [FormMixin],
  data(){
    return {
      model:{
        name: '',
        remarks:''
      },
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
  components:{FixedHeader},
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  created(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    onView() {
      this.$router.push('/master_files/currency')
    },
    ...mapActions('currency', ['create', 'find']),
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    }
  },
  beforeMount() {
    this.find({
      id:this.$route.query.id
    }).then(data => {
      this.model = data.data
    })
    this.model.id = this.$route.query.id
  }
}
</script>

